// Quotation API service. Talks to our FastAPI proxy which forwards to the
// Blexbot / Delamano upstream, carrying the customer's authenticated
// WhatsApp session cookies that were established at sign-in.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getSessionToken = () => {
  try {
    return sessionStorage.getItem("pv_session_token") || "";
  } catch {
    return "";
  }
};

const withAuthHeaders = (extra = {}) => ({
  "X-PV-Session": getSessionToken(),
  ...extra,
});

const unwrapError = (err) => {
  const upstream =
    err?.response?.data?.detail ||
    err?.response?.data?.error ||
    err?.response?.data?.message;
  if (upstream) return new Error(upstream);
  if (err?.message) return new Error(err.message);
  return new Error("Unknown network error");
};

export const priceRequestsApi = {
  async getData() {
    try {
      const { data } = await axios.get(`${API}/price_requests/data`, {
        headers: withAuthHeaders(),
      });
      return data;
    } catch (err) {
      throw unwrapError(err);
    }
  },

  async createRequest(formData) {
    try {
      const { data } = await axios.post(`${API}/create_price_request`, formData, {
        headers: withAuthHeaders({ "Content-Type": "multipart/form-data" }),
      });
      return data;
    } catch (err) {
      throw unwrapError(err);
    }
  },

  async listMine() {
    try {
      const { data } = await axios.get(`${API}/price_requests/my_requests`, {
        headers: withAuthHeaders(),
      });
      return data;
    } catch (err) {
      throw unwrapError(err);
    }
  },
};

export default priceRequestsApi;
